
<button
  ref="buttonRef"
  data-tooltip-text="Prevent non-owners from editing"
  data-tooltip-position="below"
  :class="{
    MenuButton: true,
    'm-locked': value,
  }"
  v-on:click="onClick"
>
  <img
    :src="'/img/icons/lock-open-outline-white.svg'"
    v-if="!value"
    :class="{ 'm-full-size': !value }"
  />
  <img :src="'/img/icons/lock-closed-outline-white.svg'" v-if="value" />
  <span v-if="value">Locked</span>
</button>
